import * as Cesium from "cesium";
import { DesignMaterialItemDto, FileStateEnum } from "~/api/GeneratedApi";
import { cadToCesiumMapItem } from "./dataConverters";

export function cadToCesium(
  viewer: Cesium.Viewer,
  designMaterials: DesignMaterialItemDto[],
): void {
  designMaterials.forEach((d) => {
    // Convert to internal type
    const conv = cadToCesiumMapItem(d);
    conv.forEach((c) => {
      if (!c.state || c.state !== FileStateEnum.Done) return;
      // Update or add
      const entity = viewer.entities.getById(c.mapId);
      if (entity) {
        entity.properties = new Cesium.PropertyBag({
          ...c,
        });
      } else {
        viewer.entities.add({
          id: c.mapId,
          properties: new Cesium.PropertyBag({
            ...c,
          }),
        });
      }
    });
  });
}
